import Vue from 'vue'
import App from './App.vue'
import router from './router'

import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/css/igp.css";

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App),
    renderError(h, err) {
        return h('pre', {style: {color: 'red'}}, err.stack)
    }
}).$mount('#app')
